import { useContext } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { encryptURL, status } from 'utils/functions';
import { ArmazenagemContext } from 'contexts/ArmazenagemContext';
import Container from 'components/Container';
import Stepper from 'components/Stepper';
import Header from 'components/Header';
import Documentos from './Steps/Documentos';
import Lotes from './Steps/Lotes';
import styles from './styles';

const renderComponent = (props) => {
  switch (props?.index) {
    case 0:
      return <Documentos {...props} />;
    case 1:
      return <Lotes {...props} />;
    default:
      return null;
  }
};

const Armazenagem = () => {
  const navigate = useNavigate();
  const titulo = 'Recebimento & Armazenagem';
  const { lotesLoading, getLotes, documentosLoading, getDocumentos } =
    useContext(ArmazenagemContext);

  const steps = [
    {
      ...status?.RECEBIMENTO,
      titulo: 'Documentos',
      visible: true,
      loading: documentosLoading,
      fetch: (params, cb) => getDocumentos({ params, cb }),
      actions: [
        {
          name: 'Conferir',
          icon: status?.RECEBIMENTO?.icon,
          show: true,
          action: (arr) =>
            navigate(`/app/Armazenagem/Conferencia/${encryptURL(arr)}`),
        },
      ],
    },
    {
      ...status?.ARMAZENAGEM,
      titulo: 'Lotes',
      visible: true,
      loading: lotesLoading,
      fetch: (params, cb) => getLotes({ params, cb }),
      actions: [
        {
          name: 'Armazenar',
          icon: status?.ARMAZENAGEM?.icon,
          show: true,
          action: (arr) => navigate(`/app/Armazenagem/${encryptURL(arr)}`),
        },
      ],
    },
  ];

  return (
    <Container>
      <Header titulo={titulo} />
      <Box sx={styles?.container}>
        {steps
          ?.filter((f) => Boolean(f?.visible))
          ?.map((props, index) => (
            <Stepper
              {...props}
              index={index}
              key={index?.toString()}
              renderComponent={renderComponent}
            />
          ))}
      </Box>
    </Container>
  );
};

export default Armazenagem;
